import { axiosCallService } from "../common/apiCallService.js";

export const getReportCardDeatils = data =>
  axiosCallService(`/reportCard/playerStats`, data);

export const getMyStatistics = data =>
  axiosCallService(`/reportCard/myStatistics`, data);


export const getHandInfoList = data => {
  if(localStorage.getItem("userRole").indexOf("PLAYER") == -1){
    return [];
  }
  return axiosCallService(`/handInfo/getHandInfoList`, data);
}
  

export const getPlayerLevelsSaga = data =>
  axiosCallService(`/reportCard/getPlayerLevels`, data);

export const getPlayerGameSubTypesSaga = data =>
  axiosCallService(`/reportCard/getPlayerGameSubTypes`, data);

export const getPlayerHitTypesSaga = data =>
  axiosCallService(`/reportCard/getPlayerHitTypes`, data);

export const getMissions = data =>
  axiosCallService(`/missions/getMissions`, data);

export const getMedalDeatils = data =>
  axiosCallService(`/summaryInfo/list`, data);

export const getStarDetails = data => axiosCallService(`/star/list`, data);

export const getPromotionalContent = data =>
  axiosCallService("/reportCard/getPromotionalContent", data);



/** WEBPACK FOOTER **
 ** ./src/endPoints/multipleReportCards.js
 **/